"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyResult = exports.IdentifyObjs = void 0;
var math = require("mathjs");
var BaseGeometry = /** @class */ (function () {
    function BaseGeometry(points) {
        this.points = points;
    }
    Object.defineProperty(BaseGeometry.prototype, "vertexes", {
        get: function () {
            return this.points;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseGeometry.prototype, "boundingBox", {
        get: function () {
            var angle = this.includedAngle(this.points[0], this.points[1]);
            var rotateGemotry = this.rotate(angle);
            var minX = Number.POSITIVE_INFINITY;
            var maxX = Number.NEGATIVE_INFINITY;
            var minY = Number.POSITIVE_INFINITY;
            var maxY = Number.NEGATIVE_INFINITY;
            rotateGemotry.vertexes.map(function (_a) {
                var x = _a[0], y = _a[1];
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            });
            var boxGemotry = [];
            boxGemotry.push([minX, minY]);
            boxGemotry.push([maxX, minY]);
            boxGemotry.push([maxX, maxY]);
            boxGemotry.push([minX, maxY]);
            return boxGemotry;
        },
        enumerable: false,
        configurable: true
    });
    BaseGeometry.prototype.includedAngle = function (line1, line2) {
        var dot = this.dotProduct(line1, line2);
        var len1 = Math.sqrt(this.dotProduct(line1, line1));
        var len2 = Math.sqrt(this.dotProduct(line2, line2));
        return Math.acos(dot / (len1 * len2));
    };
    BaseGeometry.prototype.dotProduct = function (a, b) {
        return a[0] * b[0] + a[1] * b[1];
    };
    Object.defineProperty(BaseGeometry.prototype, "horizontal", {
        get: function () {
            var pointA = math.matrix(this.points[0]);
            var pointB = math.matrix(this.points[1]);
            var line = math.subtract(pointB, pointA);
            var rotationMatrix = math.matrix([[0, -1], [1, 0]]); //顺时针旋转90度
            var rotatedVector = math.multiply(line, rotationMatrix).toJSON().data;
            var length = Math.sqrt(rotatedVector[0] * rotatedVector[0] + rotatedVector[1] * rotatedVector[1]);
            return [rotatedVector[0] / length, rotatedVector[1] / length];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseGeometry.prototype, "vertical", {
        get: function () {
            var pointA = math.matrix(this.points[0]);
            var pointB = math.matrix(this.points[1]);
            var rotatedVector = math.subtract(pointB, pointA).toJSON().data;
            // const length = Math.sqrt(rotatedVector[0] * rotatedVector[0] + rotatedVector[1] * rotatedVector[1]);
            // return [rotatedVector[0] / length, rotatedVector[1] / length];
            return [rotatedVector[0] + this.points[0][0], rotatedVector[1] + this.points[0][1]];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseGeometry.prototype, "position", {
        get: function () {
            var x = (this.points[0][0] + this.points[2][0]) / 2;
            var y = (this.points[0][1] + this.points[2][1]) / 2;
            return [x, y];
        },
        enumerable: false,
        configurable: true
    });
    BaseGeometry.prototype.rotate = function (angle) {
        var center = this.position;
        var g = this.translate(-(center[0]), -(center[1]));
        var rotatePoints = [];
        g.vertexes.map(function (point) {
            var x = point[0] * Math.cos(angle) - point[1] * Math.sin(angle);
            var y = point[0] * Math.sin(angle) + point[1] * Math.cos(angle);
            rotatePoints.push([x, y]);
        });
        rotatePoints.map(function (point) {
            point[0] = point[0] + center[0];
            point[1] = point[1] + center[1];
        });
        return new BaseGeometry(rotatePoints);
    };
    BaseGeometry.prototype.translate = function (x, y) {
        var translatePoints = [];
        this.points.map(function (point) {
            translatePoints.push([point[0] + x, point[1] + y]);
        });
        return new BaseGeometry(translatePoints);
    };
    BaseGeometry.prototype.scale = function (size) {
        var center = this.position;
        var g = this.translate(-(center[0]), -(center[1]));
        var scalePoints = [];
        g.vertexes.map(function (point) {
            var x = point[0] * size;
            var y = point[1] * size;
            scalePoints.push([x, y]);
        });
        scalePoints.map(function (point) {
            point[0] = point[0] + center[0];
            point[1] = point[1] + center[1];
        });
        return new BaseGeometry(scalePoints);
    };
    BaseGeometry.prototype.scaleX = function (size) {
        var center = this.position;
        var g = this.translate(-(center[0]), -(center[1]));
        var scalePoints = [];
        g.vertexes.map(function (point) {
            var x = point[0] * size;
            scalePoints.push([x, point[1]]);
        });
        scalePoints.map(function (point) {
            point[0] = point[0] + center[0];
            point[1] = point[1] + center[1];
        });
        return new BaseGeometry(scalePoints);
    };
    BaseGeometry.prototype.scaleY = function (size) {
        var center = this.position;
        var g = this.translate(-(center[0]), -(center[1]));
        var scalePoints = [];
        g.vertexes.map(function (point) {
            var y = point[1] * size;
            scalePoints.push([point[0], y]);
        });
        scalePoints.map(function (point) {
            point[0] = point[0] + center[0];
            point[1] = point[1] + center[1];
        });
        return new BaseGeometry(scalePoints);
    };
    BaseGeometry.prototype.compute = function (x1, y1, x2, y2) {
        return x1 * y2 - y1 * x2;
    };
    BaseGeometry.prototype.lineIntersect = function (po0, po1, po2, po3) {
        // 线段AB与线段CD相交，于是我们可以得到两个向量AC，AD，C和D分别在AB的两边，向量AC在向量AB的逆势针方向，AB×AC > 0；向量AD在向量AB的顺势针方向，AB×AD < 0，两叉乘结果异号
        var num1 = this.compute(po0[0] - po1[0], po0[1] - po1[1], po0[0] - po2[0], po0[1] - po2[1]); //计算第一条的两个端点
        var num2 = this.compute(po0[0] - po1[0], po0[1] - po1[1], po0[0] - po3[0], po0[1] - po3[1]); //在第二条线段的两边
        var num3 = this.compute(po0[0] - po2[0], po0[1] - po2[1], po2[0] - po3[0], po2[1] - po3[1]); //计算第二条的两个端点
        var num4 = this.compute(po1[0] - po2[0], po1[1] - po2[1], po2[0] - po3[0], po2[1] - po3[1]); //在第一条线段的两边
        if (num1 * num2 < 0 && num3 * num4 <= 0 || num1 * num2 <= 0 && num3 * num4 < 0) {
            return true;
        }
        // 如果p0p1和p2p3相交，则返回true
        return false;
    };
    return BaseGeometry;
}());
var Page = /** @class */ (function () {
    function Page(elements) {
        var _this = this;
        this.elements = [];
        this.maxX = 0;
        this.maxY = 0;
        this.detailMin = 0;
        this.detailMax = 0;
        this.partitionOne = [];
        this.partitionTwo = [];
        this.partitionThr = [];
        this.partitionFou = [];
        var minY = 0;
        this.elements = elements;
        this.elements.map(function (element) {
            if (element.geometry.points[1][0] > _this.maxX)
                _this.maxX = element.geometry.points[1][0];
            if (element.geometry.points[1][1] > _this.maxY)
                _this.maxY = element.geometry.points[1][1];
            if (element.content.includes('税率'))
                minY = element.geometry.points[0][1];
        });
        this.detailMin = minY;
        this.divideArea();
    }
    Object.defineProperty(Page.prototype, "transverseLength", {
        get: function () {
            return this.maxX;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "detailHeight", {
        get: function () {
            return this.detailMax;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Page.prototype, "portraitLength", {
        get: function () {
            return this.maxY;
        },
        enumerable: false,
        configurable: true
    });
    Page.prototype.getElementById = function (id) {
        var ele;
        this.elements.map(function (element) {
            if (element.id === id)
                ele = element;
        });
        return ele;
    };
    Page.prototype.divideArea = function () {
        var _this = this;
        this.elements.map(function (element) {
            if (element.geometry.position[0] <= _this.maxX / 2 && element.geometry.position[1] <= _this.maxY / 2)
                _this.partitionOne.push(element);
            if (element.geometry.position[0] > _this.maxX / 2 && element.geometry.position[1] <= _this.maxY / 2)
                _this.partitionTwo.push(element);
            if (element.geometry.position[0] > _this.maxX / 2 && element.geometry.position[1] > _this.maxY / 2)
                _this.partitionThr.push(element);
            if (element.geometry.position[0] <= _this.maxX / 2 && element.geometry.position[1] > _this.maxY / 2)
                _this.partitionFou.push(element);
        });
    };
    Page.prototype.setDetailHeight = function (length) {
        this.detailMax = length;
    };
    return Page;
}());
var Element = /** @class */ (function () {
    function Element(id, geometry, content, score) {
        this.id = id;
        this.geometry = geometry;
        this.content = content;
        this.score = score;
    }
    return Element;
}());
var IdentifyResult = /** @class */ (function () {
    function IdentifyResult(enName, chName, value) {
        this.enName = enName;
        this.chName = chName;
        this.value = value;
    }
    return IdentifyResult;
}());
exports.IdentifyResult = IdentifyResult;
var IdentifyObjs = /** @class */ (function () {
    function IdentifyObjs() {
        this.pages = [];
        this.type = '1'; // 0 增值税普通发票；1 增值税专用发票； 2 电子普通发票；3 电子火车票; 5 电子统一会费； 4 飞机票行程单；
    }
    IdentifyObjs.prototype.analysisDatas = function (datas) {
        var _this = this;
        datas.map(function (data) {
            var page = [];
            var nC = 0;
            data.map(function (element) {
                var geometry = new BaseGeometry(element[0]);
                var content = String(element[1][0]);
                var score = Number(element[1][1]);
                var ele = new Element(nC, geometry, content, score);
                nC++;
                page.push(ele);
            });
            var pages = new Page(page);
            _this.pages.push(pages);
        });
        var resultpages = [];
        this.type = this.getBillType(this.pages[0]);
        if (this.type === '0' || this.type === '1' || this.type === '2') {
            var invoice_1 = new Invoice(this.pages);
            invoice_1.analysePreprocessing(this.pages);
            this.pages.map(function (page) {
                var results = [], identifyResult;
                identifyResult = new IdentifyResult('invoiceType', '类型', [_this.type]);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceNo', '发票代码', invoice_1.analyseInvoice(_this.type, '发票代码', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceCode', '发票号码', invoice_1.analyseInvoice(_this.type, '发票号码', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceDate', '开票日期', invoice_1.analyseInvoice(_this.type, '开票日期', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('buyer', '购买方名称', invoice_1.analyseInvoice(_this.type, '购买方名称', page));
                results.push(identifyResult);
                var taxNum = invoice_1.analyseInvoice(_this.type, '购买方纳税人识别号', page);
                if (taxNum[0]) {
                    taxNum = taxNum[0].replace(/O/g, '0');
                }
                identifyResult = new IdentifyResult('buyerTax', '购买方纳税人识别号', taxNum);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('seller', '销售方名称', invoice_1.analyseInvoice(_this.type, '销售方名称', page));
                results.push(identifyResult);
                taxNum = invoice_1.analyseInvoice(_this.type, '销售方纳税人识别号', page);
                if (taxNum[0]) {
                    taxNum = taxNum[0].replace(/O/g, '0');
                }
                identifyResult = new IdentifyResult('sellerTax', '销售方纳税人识别号', taxNum);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('entryName', '项目名称', invoice_1.analyseInvoice(_this.type, '项目名称', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('serviceName', '服务名称', invoice_1.analyseInvoice(_this.type, '服务名称', page));
                results.push(identifyResult);
                var m = invoice_1.analyseInvoice(_this.type, '金额', page);
                if (invoice_1.hasChineseCharacters(m))
                    identifyResult = new IdentifyResult('amount', '金额', ['0']);
                else
                    identifyResult = new IdentifyResult('amount', '金额', m);
                results.push(identifyResult);
                var l = invoice_1.analyseInvoice(_this.type, '税率', page);
                if (invoice_1.hasChineseCharacters(l))
                    identifyResult = new IdentifyResult('taxRate', '税率', ['0%']);
                else if (l.length > 0)
                    identifyResult = new IdentifyResult('taxRate', '税率', l);
                else
                    identifyResult = new IdentifyResult('taxRate', '税率', ['0%']);
                results.push(identifyResult);
                var e = invoice_1.analyseInvoice(_this.type, '税额', page);
                if (invoice_1.hasChineseCharacters(e))
                    identifyResult = new IdentifyResult('taxMoney', '税额', '0');
                else
                    identifyResult = new IdentifyResult('taxMoney', '税额', e);
                results.push(identifyResult);
                var jh = invoice_1.analyseInvoice(_this.type, '合计', page);
                if (invoice_1.hasChineseCharacters(jh))
                    identifyResult = new IdentifyResult('taxExcludedAmount', '价格合计', '0');
                else
                    identifyResult = new IdentifyResult('taxExcludedAmount', '价格合计', jh);
                results.push(identifyResult);
                var sh = invoice_1.analyseInvoice(_this.type, '税额合计', page);
                if (invoice_1.hasChineseCharacters(sh))
                    identifyResult = new IdentifyResult('taxAmount', '税额合计', ['0']);
                else {
                    if (sh[0])
                        sh = sh[0].replace('￥', '');
                    identifyResult = new IdentifyResult('taxAmount', '税额合计', sh);
                }
                results.push(identifyResult);
                identifyResult = new IdentifyResult('capitalTotal', '价税合计(大写)', invoice_1.analyseInvoice(_this.type, '价税合计(大写)', page));
                results.push(identifyResult);
                var xh = invoice_1.analyseInvoice(_this.type, '价税合计(小写)', page);
                if (invoice_1.hasChineseCharacters(xh))
                    identifyResult = new IdentifyResult('invoiceAmount', '价税合计(小写)', '0');
                else
                    identifyResult = new IdentifyResult('invoiceAmount', '价税合计(小写)', xh);
                results.push(identifyResult);
                resultpages.push(results);
            });
        }
        else if (this.type === '3') {
            var tickets_1 = new TrainTickets(this.pages);
            this.pages.map(function (page) {
                var results = [], identifyResult;
                identifyResult = new IdentifyResult('invoiceType', '类型', [_this.type]);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceCode', '发票号码', tickets_1.getElementByContent(_this.type, '发票号码', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceDate', '开票日期', tickets_1.getElementByContent(_this.type, '开票日期', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('departureStation', '始发站', tickets_1.getElementByContent(_this.type, '始发站', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('arriveStation', '到达站', tickets_1.getElementByContent(_this.type, '到达站', page));
                results.push(identifyResult);
                var pj = tickets_1.getElementByContent(_this.type, '票价', page);
                if (pj) {
                    pj = pj.replace('_', '.');
                    pj = pj.replace('O', '0');
                }
                identifyResult = new IdentifyResult('ticketPrice', '票价', pj);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('passenger', '乘车人', tickets_1.getElementByContent(_this.type, '乘车人', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('buyer', '购买方名称', tickets_1.getElementByContent(_this.type, '购买方名称', page));
                results.push(identifyResult);
                var taxNum = tickets_1.getElementByContent(_this.type, '统一社会信用代码', page);
                if (taxNum)
                    taxNum = taxNum.replace('O', '0');
                identifyResult = new IdentifyResult('buyerTax', '统一社会信用代码', taxNum);
                results.push(identifyResult);
                var ccsj = tickets_1.getElementByContent(_this.type, '乘车时间', page);
                if (!ccsj.content.includes('年') || !ccsj.content.includes('月') || !ccsj.content.includes('日'))
                    ccsj.content = '';
                identifyResult = new IdentifyResult('travelTime', '乘车时间', ccsj);
                results.push(identifyResult);
                resultpages.push(results);
            });
        }
        else if (this.type === '5') {
            var invoice_2 = new Invoice(this.pages);
            invoice_2.analysePreprocessing(this.pages);
            this.pages.map(function (page) {
                var results = [], identifyResult;
                identifyResult = new IdentifyResult('invoiceType', '类型', ['2']);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceCode', '发票号码', invoice_2.analyseInvoice(_this.type, '票据号码：', page));
                results.push(identifyResult);
                var date1 = invoice_2.analyseInvoice(_this.type, '开票日期：', page);
                if (date1[0].split('-').length > 1) {
                    var strDates = date1[0].split('-');
                    date1[0] = '';
                    for (var i = 0; i < strDates.length; i++) {
                        date1[0] = date1[0] + strDates[i];
                    }
                    date1[0] = date1[0].substring(0, 4) + '年' + date1[0].substring(4, 6) + '月' + date1[0].substring(6, 8) + '日';
                }
                identifyResult = new IdentifyResult('invoiceDate', '开票日期', date1);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('buyer', '购买方名称', invoice_2.analyseInvoice(_this.type, '交款人：', page));
                results.push(identifyResult);
                var taxNum = invoice_2.analyseInvoice(_this.type, '交款人统一社会信用代码：', page);
                if (taxNum[0]) {
                    taxNum = taxNum[0].replace(/O/g, '0');
                }
                identifyResult = new IdentifyResult('buyerTax', '购买方纳税人识别号', taxNum);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('taxRate', '税率', '0%');
                results.push(identifyResult);
                identifyResult = new IdentifyResult('taxMoney', '税额', '0');
                results.push(identifyResult);
                identifyResult = new IdentifyResult('taxAmount', '税额合计', '0');
                results.push(identifyResult);
                identifyResult = new IdentifyResult('capitalTotal', '价税合计(大写)', invoice_2.analyseInvoice(_this.type, '金额合计（大写）', page));
                results.push(identifyResult);
                var xh = invoice_2.analyseInvoice(_this.type, '（小写）', page);
                if (invoice_2.hasChineseCharacters(xh))
                    identifyResult = new IdentifyResult('invoiceAmount', '价税合计(小写)', '0');
                else
                    identifyResult = new IdentifyResult('invoiceAmount', '价税合计(小写)', xh);
                results.push(identifyResult);
                resultpages.push(results);
            });
        }
        else if (this.type === '6') {
            var tickets_2 = new AirTickets(this.pages);
            tickets_2.analysePreprocessing(this.pages);
            this.pages.map(function (page) {
                var results = [], identifyResult;
                identifyResult = new IdentifyResult('invoiceType', '类型', ['4']);
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceCode', '发票号码', tickets_2.getElementByContent(_this.type, '发票号码', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceDate', '填开日期', tickets_2.getElementByContent(_this.type, '开票日期', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('passenger', '旅客姓名', tickets_2.getElementByContent(_this.type, '旅客姓名', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('buyer', '购买方名称', tickets_2.getElementByContent(_this.type, '购买方名称', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('buyerTax', '统一社会信用代码', tickets_2.getElementByContent(_this.type, '统一社会信用代码/纳税人识别号', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('seller', '填开单位', tickets_2.getElementByContent(_this.type, '填开单位', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('ticketPrice', '票价', tickets_2.getElementByContent(_this.type, '票价', page));
                results.push(identifyResult);
                resultpages.push(results);
                identifyResult = new IdentifyResult('taxRate', '增值税税率', tickets_2.getElementByContent(_this.type, '增值税税率', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('taxAmount', '增值税税额', tickets_2.getElementByContent(_this.type, '增值税税额', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('fuelFee', '燃油附加费', tickets_2.getElementByContent(_this.type, '燃油附加费', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('civilFund', '民航发展基金', tickets_2.getElementByContent(_this.type, '民航发展基金', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('otherFees', '其他税费', tickets_2.getElementByContent(_this.type, '其他税费', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('invoiceAmount', '合计', tickets_2.getElementByContent(_this.type, '合计', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('departureStation', '始发站', tickets_2.getElementByContent(_this.type, '自：', page));
                results.push(identifyResult);
                identifyResult = new IdentifyResult('arriveStation', '到达站', tickets_2.getElementByContent(_this.type, '至：', page));
                results.push(identifyResult);
            });
        }
        return resultpages;
    };
    IdentifyObjs.prototype.getBillType = function (page) {
        var flag1 = 0, flag2 = 0, flag3 = 0, flag = '2';
        page.elements.map(function (element) {
            if (element.content.includes('增') && flag1 == 0) {
                flag1 = 1;
            }
            if (element.content.includes('全国性') || element.content.includes('会费') && flag1 == 0) {
                flag1 = 4;
            }
            if (element.content.includes('电子') &&
                !element.content.includes('客票') && !element.content.includes('票据')
                && !element.content.includes('行程') && flag2 == 0) {
                flag2 = 2;
            }
            if (element.content.includes('普通发票') && flag3 == 0) {
                flag3 = 1;
            }
            if (element.content.includes('专用') && !element.content.includes('发票专用章') && flag3 == 0) {
                flag3 = 2;
            }
            if (element.content === '仅供报销使用' && flag1 == 0) {
                flag1 = 3;
            }
            if (element.content.includes('客票') && !element.content.includes('行程') && flag1 == 0) {
                flag1 = 2;
                flag2 = 2;
            }
            if (element.content.includes('行程') && flag1 == 0) {
                flag1 = 5;
                flag2 = 5;
            }
        });
        if (flag1 === 1 && flag3 === 1)
            flag = '0';
        if (flag1 === 1 && flag3 === 2)
            flag = '1';
        if (flag1 === 0 && flag2 === 2 && flag3 === 1)
            flag = '2';
        if (flag1 === 0 && flag2 === 2 && flag3 === 0)
            flag = '2';
        if (flag1 === 4)
            flag = '5';
        if (flag1 === 3)
            flag = '3';
        if (flag1 === 2 && flag2 === 2)
            flag = '3';
        if (flag1 === 5 && flag2 === 5)
            flag = '6';
        return flag;
    };
    return IdentifyObjs;
}());
exports.IdentifyObjs = IdentifyObjs;
var Invoice = /** @class */ (function () {
    function Invoice(pages) {
        this.pages = [];
        this.pages = pages;
    }
    Invoice.prototype.analyseInvoice = function (type, containStr, page) {
        var contentList = [];
        switch (type) {
            case '0':
                contentList = this.analysisZZSPTFP(containStr, page);
                break;
            case '1':
                contentList = this.analysisZZSZYFP(containStr, page);
                break;
            case '2':
                contentList = this.analysisDZPTFP(containStr, page);
                break;
            case '5':
                contentList = this.analysisHFFP(containStr, page);
                break;
        }
        return contentList;
    };
    Invoice.prototype.hasChineseCharacters = function (str) {
        return /[\u4e00-\u9fa5]/.test(str);
    };
    Invoice.prototype.getElementByContentInPartition = function (partition, page, content1, content2) {
        var ele;
        switch (partition) {
            case 0:
                page.partitionOne.map(function (element) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                    }
                });
                break;
            case 1:
                page.partitionTwo.map(function (element) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                    }
                });
                break;
            case 2:
                page.partitionThr.map(function (element) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                    }
                });
                break;
            case 3:
                page.partitionFou.map(function (element) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                    }
                });
                break;
        }
        return ele;
    };
    Invoice.prototype.cyclePartitionFind = function (partition, content) {
        var id = 0, k = 0;
        partition.map(function (element) {
            if (element.content.includes(content) && id == 0)
                id = k;
            k++;
        });
        return id;
    };
    Invoice.prototype.getElementByContent = function (page, content1, content2, content3) {
        var ele;
        page.partitionOne.map(function (element) {
            if (!ele) {
                if (content2 !== '') {
                    if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                        ele = element;
                    }
                    if (content3 !== '' && ele) {
                        var ele1 = page.getElementById(ele.id + 1);
                        if (!ele1.content.includes(content3))
                            ele = undefined;
                    }
                }
                else {
                    if (element.content.includes(content1)) {
                        ele = element;
                    }
                    if (content3 !== '' && ele) {
                        var ele1 = page.getElementById(ele.id + 1);
                        if (!ele1.content.includes(content3))
                            ele = undefined;
                    }
                }
            }
        });
        if (!ele) {
            page.partitionTwo.map(function (element) {
                if (!ele) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                        if (content3 !== '' && ele) {
                            var ele1 = page.getElementById(ele.id + 1);
                            if (!ele1.content.includes(content3))
                                ele = undefined;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                        if (content3 !== '' && ele) {
                            var ele1 = page.getElementById(ele.id + 1);
                            if (!ele1.content.includes(content3))
                                ele = undefined;
                        }
                    }
                }
            });
        }
        if (!ele) {
            page.partitionThr.map(function (element) {
                if (!ele) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                        if (content3 !== '' && ele) {
                            var ele1 = page.getElementById(ele.id + 1);
                            if (!ele1.content.includes(content3))
                                ele = undefined;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                        if (content3 !== '' && ele) {
                            var ele1 = page.getElementById(ele.id + 1);
                            if (!ele1.content.includes(content3))
                                ele = undefined;
                        }
                    }
                }
            });
        }
        if (!ele) {
            page.partitionFou.map(function (element) {
                if (!ele) {
                    if (content2 !== '') {
                        if (element.content.includes(content1) && !element.content.includes(content2) && !element.content.includes('纳')) {
                            ele = element;
                        }
                        if (content3 !== '' && ele) {
                            var ele1 = page.getElementById(ele.id + 1);
                            if (!ele1.content.includes(content3))
                                ele = undefined;
                        }
                    }
                    else {
                        if (element.content.includes(content1)) {
                            ele = element;
                        }
                        if (content3 !== '' && ele) {
                            var ele1 = page.getElementById(ele.id + 1);
                            if (!ele1.content.includes(content3))
                                ele = undefined;
                        }
                    }
                }
            });
        }
        return ele;
    };
    Invoice.prototype.getElementEquateContent = function (page, content1) {
        var ele;
        page.partitionOne.map(function (element) {
            if (!ele) {
                if (element.content === (content1)) {
                    ele = element;
                }
            }
        });
        if (!ele) {
            page.partitionTwo.map(function (element) {
                if (!ele) {
                    if (element.content === (content1)) {
                        ele = element;
                    }
                }
            });
        }
        if (!ele) {
            page.partitionThr.map(function (element) {
                if (!ele) {
                    if (element.content === (content1)) {
                        ele = element;
                    }
                }
            });
        }
        if (!ele) {
            page.partitionFou.map(function (element) {
                if (!ele) {
                    if (element.content === (content1)) {
                        ele = element;
                    }
                }
            });
        }
        return ele;
    };
    Invoice.prototype.analysePreprocessing = function (pages) {
        var _this = this;
        pages.map(function (page) {
            var ele1 = _this.getElementByContent(page, '合计', '大写', '');
            if (!ele1) {
                ele1 = _this.getElementEquateContent(page, '合');
                var ele2 = _this.getElementEquateContent(page, '计');
                if (ele2 && ele1) {
                    _this.totalGeometry = new BaseGeometry([ele1.geometry.points[0], ele2.geometry.points[1], ele2.geometry.points[2], ele1.geometry.points[3]]);
                    page.elements.push(new Element(page.elements.length, _this.totalGeometry, '合计', ele2.score));
                    page.partitionFou.push(new Element(page.elements.length, _this.totalGeometry, '合计', ele2.score));
                    if (_this.totalGeometry) {
                        page.setDetailHeight(Number(_this.totalGeometry.points[0][1] - 2 * (_this.totalGeometry.points[2][1] - _this.totalGeometry.points[1][1])));
                    }
                }
                else if (ele2) {
                    _this.totalGeometry = new BaseGeometry([ele2.geometry.points[0], ele2.geometry.points[1], ele2.geometry.points[2], ele2.geometry.points[3]]);
                    page.elements.push(new Element(page.elements.length, _this.totalGeometry, '合计', ele2.score));
                    page.partitionFou.push(new Element(page.elements.length, _this.totalGeometry, '合计', ele2.score));
                    if (_this.totalGeometry) {
                        page.setDetailHeight(Number(_this.totalGeometry.points[0][1] - 2 * (_this.totalGeometry.points[2][1] - _this.totalGeometry.points[1][1])));
                    }
                }
            }
            else {
                page.setDetailHeight(Number(ele1.geometry.points[0][1] - (ele1.geometry.points[2][1] - ele1.geometry.points[1][1])));
            }
            if (!_this.getElementByContent(page, '金额', '', '')) {
                var ele1_1 = _this.getElementByContent(page, '金', '', '额');
                if (ele1_1) {
                    var ele2 = page.getElementById(ele1_1.id + 1);
                    if (ele2.content === '额') {
                        _this.totalGeometry = new BaseGeometry([ele1_1.geometry.points[0], ele2.geometry.points[1], ele2.geometry.points[2], ele1_1.geometry.points[3]]);
                        var ele3_1 = page.getElementById(ele2.id + 1);
                        if (ele3_1.content.includes('税')) {
                            _this.totalGeometry.points[1][0] = ele3_1.geometry.points[0][0] - (ele3_1.geometry.points[1][0] - ele3_1.geometry.points[0][0]) / 2;
                            _this.totalGeometry.points[2][0] = ele3_1.geometry.points[3][0] - (ele3_1.geometry.points[2][0] - ele3_1.geometry.points[3][0]) / 2;
                        }
                        var ele = new Element(page.elements.length, _this.totalGeometry, '金额', ele2.score);
                        page.elements.push(ele);
                        page.partitionTwo.push(ele);
                    }
                }
            }
            else {
                var ele1_2 = _this.getElementByContent(page, '金额', '', '');
                var ele2 = page.getElementById(ele1_2.id + 1);
                if (ele2.content.includes('税')) {
                    ele1_2.geometry.points[1][0] = ele2.geometry.points[0][0] - (ele2.geometry.points[1][0] - ele2.geometry.points[0][0]) / 2;
                    ele1_2.geometry.points[2][0] = ele2.geometry.points[3][0] - (ele2.geometry.points[2][0] - ele2.geometry.points[3][0]) / 2;
                }
            }
            if (_this.getElementByContent(page, '税率', '', '')) {
                var ele1_3 = _this.getElementByContent(page, '税率', '', '');
                var ele2 = page.getElementById(ele1_3.id + 1);
                if (ele2.content.includes('税额') && ele1_3.content === '税率') {
                    ele1_3.geometry.points[1][0] = ele2.geometry.points[0][0] - (ele2.geometry.points[1][0] - ele2.geometry.points[0][0]) / 2;
                    ele1_3.geometry.points[2][0] = ele2.geometry.points[3][0] - (ele2.geometry.points[2][0] - ele2.geometry.points[3][0]) / 2;
                }
            }
            if (!_this.getElementByContent(page, '税额', '', '')) {
                var ele1_4 = _this.getElementByContent(page, '税', '税率', '额');
                if (ele1_4) {
                    var ele2 = page.getElementById(ele1_4.id + 1);
                    if (ele2.content.includes('额')) {
                        _this.totalGeometry = new BaseGeometry([ele1_4.geometry.points[0], ele2.geometry.points[1], ele2.geometry.points[2], ele1_4.geometry.points[3]]);
                        var ele = new Element(page.elements.length, _this.totalGeometry, '税额', ele2.score);
                        page.elements.push(ele);
                        page.partitionTwo.push(ele);
                    }
                }
            }
            else {
                var ele1_5 = _this.getElementByContent(page, '税额', '', '');
                ele1_5.geometry.points[1][0] = page.transverseLength - (ele1_5.geometry.points[1][0] - ele1_5.geometry.points[0][0]) / 3;
                ele1_5.geometry.points[2][0] = page.transverseLength - (ele1_5.geometry.points[1][0] - ele1_5.geometry.points[0][0]) / 3;
            }
            if (!_this.getElementByContent(page, '小', '', '')) {
                var ele2 = void 0;
                var ele1_6 = _this.getElementByContent(page, '小', '', '计');
                if (ele1_6) {
                    ele2 = page.getElementById(ele1_6.id + 1);
                }
                if (ele1_6 && ele2) {
                    if (ele2.content === '计') {
                        _this.totalGeometry = new BaseGeometry([ele1_6.geometry.points[0], ele2.geometry.points[1], ele2.geometry.points[2], ele1_6.geometry.points[3]]);
                        var ele = new Element(page.elements.length, _this.totalGeometry, '小计', ele1_6.score);
                        page.elements.push(ele);
                        page.partitionFou.push(ele);
                    }
                }
            }
            var ele3 = _this.getElementByContent(page, '货物或应税劳务', '服务名称', '');
            if (ele3) {
                var ele2 = _this.getElementEquateContent(page, '服务名称');
                if (ele2 && ele3) {
                    _this.totalGeometry = new BaseGeometry([ele3.geometry.points[0], ele2.geometry.points[1], ele2.geometry.points[2], ele3.geometry.points[3]]);
                    page.elements.push(new Element(page.elements.length, _this.totalGeometry, '货物或应税劳务、服务名称', ele2.score));
                    page.elements.splice(ele2.id, 1);
                    page.elements.splice(ele3.id, 1);
                    var id = _this.cyclePartitionFind(page.partitionOne, '货物或应税劳务');
                    page.partitionOne.splice(id, 1);
                    id = _this.cyclePartitionFind(page.partitionOne, '服务名称');
                    page.partitionOne.splice(id, 1);
                    page.partitionOne.push(new Element(page.elements.length, _this.totalGeometry, '货物或应税劳务、服务名称', ele2.score));
                }
            }
        });
    };
    Invoice.prototype.analysisDZPTFP = function (containStr, page) {
        var contentList = [];
        if (!containStr.includes('购') && !containStr.includes('销')) {
            if ((containStr.includes('项目名称') || containStr.includes('服务名称') || containStr.includes('金额')
                || containStr.includes('税率') || containStr.includes('税额')) && containStr !== '税额合计') {
                var g = void 0, tmp_1, selElement = void 0;
                selElement = this.getElementByContent(page, containStr, '', '');
                if (selElement && selElement.geometry) {
                    g = new BaseGeometry(selElement.geometry.vertexes);
                    tmp_1 = [g.position, [g.position[0], page.detailHeight]];
                    contentList = [];
                    page.elements.map(function (element) {
                        if (element.geometry) {
                            var f = element.geometry.lineIntersect(tmp_1[0], tmp_1[1], [element.geometry.points[0][0] - 5, element.geometry.points[0][1]], [element.geometry.points[1][0] + 5, element.geometry.points[1][1]]);
                            if (f) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        }
                    });
                    if (contentList.length === 0) {
                        tmp_1 = [g.points[0], [g.points[0][0], page.detailHeight]];
                        contentList = [];
                        page.elements.map(function (element) {
                            if (element.geometry) {
                                var f = element.geometry.lineIntersect(tmp_1[0], tmp_1[1], [element.geometry.points[0][0] - 5, element.geometry.points[0][1]], [element.geometry.points[1][0] + 5, element.geometry.points[1][1]]);
                                if (f) {
                                    contentList.push(element.content.replace(/\s+/g, ''));
                                }
                            }
                        });
                    }
                    if (contentList.length === 0) {
                        g = new BaseGeometry(selElement.geometry.vertexes);
                        tmp_1 = [g.points[2], [g.points[2][0], page.detailHeight]];
                        contentList = [];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_1[0], tmp_1[1], [element.geometry.points[0][0] - 5, element.geometry.points[0][1]], [element.geometry.points[1][0] + 5, element.geometry.points[1][1]]);
                            if (f) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        });
                    }
                }
            }
            else if (containStr === '合计' || containStr === '税额合计') {
                var selElement = this.getElementByContent(page, '合计', '价税合计', '');
                if (selElement) {
                    var tmp_2 = [[selElement.geometry.points[1][0], selElement.geometry.position[1]], [page.transverseLength, selElement.geometry.position[1]]];
                    page.elements.map(function (element) {
                        var f = element.geometry.lineIntersect(tmp_2[0], tmp_2[1], element.geometry.points[0], element.geometry.points[3]);
                        if (f && contentList.length === 0) {
                            contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                        }
                        if (f && contentList.length > 0 && containStr === '税额合计') {
                            contentList.pop();
                            contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                        }
                    });
                    if (contentList.length === 0) {
                        var tmp_3 = [selElement.geometry.points[1], [page.transverseLength, selElement.geometry.points[1][1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_3[0], tmp_3[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f && contentList.length === 0) {
                                contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                            }
                            if (f && contentList.length > 0 && containStr === '税额合计') {
                                contentList.pop();
                                contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                            }
                        });
                    }
                    if (contentList.length === 0) {
                        var tmp_4 = [selElement.geometry.points[2], [page.transverseLength, selElement.geometry.points[2][1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_4[0], tmp_4[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f && contentList.length === 0) {
                                contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                            }
                            if (f && contentList.length > 0 && containStr === '税额合计') {
                                contentList.pop();
                                contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                            }
                        });
                    }
                }
            }
            else if (containStr.includes('价税合计')) {
                if (containStr.includes('大写')) {
                    var selElement = this.getElementByContent(page, '大写', '', '');
                    if (selElement) {
                        var tmp_5 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_5[0], tmp_5[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f && contentList.length === 0 && containStr.includes('大写')) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        });
                    }
                }
                else if (containStr.includes('小写')) {
                    var selElement = this.getElementByContent(page, '小写', '', '');
                    if (selElement && selElement.content.length > '（小写）'.length) {
                        contentList.push(selElement.content.substring(selElement.content.indexOf('）') + 2, selElement.content.length).replace(/\s+/g, ''));
                        if (contentList[0] === '') {
                            contentList = [];
                            var tmp_6 = [selElement.geometry.points[1], [page.transverseLength, selElement.geometry.points[1][1]]];
                            page.elements.map(function (element) {
                                var f = element.geometry.lineIntersect(tmp_6[0], tmp_6[1], element.geometry.points[1], element.geometry.points[2]);
                                if (f) {
                                    contentList.push(element.content);
                                }
                            });
                        }
                    }
                    else if (selElement) {
                        var tmp_7 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_7[0], tmp_7[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f) {
                                contentList.push(element.content.substring(element.content.indexOf(')') + 2, element.content.length).replace(/\s+/g, ''));
                            }
                        });
                    }
                }
            }
            else {
                var ele = this.getElementByContent(page, containStr, '', '');
                if (ele) {
                    if (containStr.includes('：') || containStr.includes(':'))
                        contentList.push(ele.content.substring(containStr.length, ele.content.length).replace(/\s+/g, ''));
                    else
                        contentList.push(ele.content.substring(containStr.length + 1, ele.content.length).replace(/\s+/g, ''));
                }
            }
        }
        else {
            if (containStr.includes('购买方名称')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('名称') && contentList.length === 0) {
                        if (element.content.length > 3)
                            contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                        else {
                            var ele = page.getElementById(element.id + 1);
                            contentList.push(ele.content);
                        }
                    }
                    else if (element.content.includes('称：') && contentList.length === 0) {
                        if (element.content.length > 2)
                            contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                        else {
                            var ele = page.getElementById(element.id + 1);
                            contentList.push(ele.content);
                        }
                    }
                });
            }
            if (containStr.includes('销售方名称')) {
                page.partitionTwo.map(function (element) {
                    if (element.content.includes('名称') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                    else if (element.content.includes('称：') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('购买方纳税人识别号')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('识别号')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方纳税人识别号')) {
                page.partitionTwo.map(function (element) {
                    if (element.content.includes('识别号')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
        }
        return contentList;
    };
    Invoice.prototype.analysisZZSPTFP = function (containStr, page) {
        var contentList = [];
        if (!containStr.includes('购') && !containStr.includes('销')) {
            if ((containStr.includes('服务名称') || containStr.includes('项目名称') || containStr.includes('金额')
                || containStr.includes('税率') || containStr.includes('税额')) && containStr !== '税额合计') {
                var elementId = 0;
                var g_1, tmp_8, selElement = void 0, scaleG = void 0;
                selElement = this.getElementByContent(page, containStr, '', '');
                if (selElement && selElement.geometry) {
                    g_1 = new BaseGeometry(selElement.geometry.vertexes);
                    tmp_8 = [g_1.points[0], [g_1.points[0][0], page.detailHeight]];
                    // console.log('select Geometry',g.points, selElement)
                    page.elements.map(function (element) {
                        if (g_1 && element.geometry) {
                            var f = element.geometry.lineIntersect(tmp_8[0], tmp_8[1], element.geometry.points[0], element.geometry.points[1]);
                            // console.log('page element', containStr, tmp, element, element.geometry, f)
                            if (f) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        }
                    });
                    if (contentList.length === 0) {
                        g_1 = new BaseGeometry(selElement.geometry.vertexes);
                        tmp_8 = [g_1.position, [g_1.position[0], page.detailHeight]];
                        page.elements.map(function (element) {
                            if (g_1 && element.geometry) {
                                var f = element.geometry.lineIntersect(tmp_8[0], tmp_8[1], element.geometry.points[0], element.geometry.points[1]);
                                if (f) {
                                    contentList.push(element.content.replace(/\s+/g, ''));
                                }
                            }
                        });
                    }
                    if (contentList.length === 0) {
                        g_1 = new BaseGeometry(selElement.geometry.vertexes);
                        tmp_8 = [g_1.points[2], [g_1.points[2][0], page.detailHeight]];
                        page.elements.map(function (element) {
                            if (g_1 && element.geometry) {
                                var f = element.geometry.lineIntersect(tmp_8[0], tmp_8[1], element.geometry.points[0], element.geometry.points[1]);
                                if (f) {
                                    contentList.push(element.content.replace(/\s+/g, ''));
                                }
                            }
                        });
                    }
                }
            }
            else if (containStr === '合计' || containStr === '税额合计') {
                var selElement = this.getElementByContent(page, '合计', '价税合计', '');
                var tmp_9 = [[selElement.geometry.points[1][0], selElement.geometry.position[1]], [page.transverseLength, selElement.geometry.position[1]]];
                page.elements.map(function (element) {
                    var f = element.geometry.lineIntersect(tmp_9[0], tmp_9[1], element.geometry.points[0], element.geometry.points[3]);
                    if (f && contentList.length === 0) {
                        contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                    }
                    if (f && contentList.length > 0 && containStr === '税额合计') {
                        contentList.pop();
                        contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                    }
                });
            }
            else if (containStr.includes('价税合计') && containStr !== '合计') {
                var selElement = this.getElementByContent(page, '价税合计', '', '');
                var tmp_10 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                page.elements.map(function (element) {
                    var f = element.geometry.lineIntersect(tmp_10[0], tmp_10[1], element.geometry.points[0], element.geometry.points[3]);
                    if (f && contentList.length === 0 && containStr.includes('大写')) {
                        contentList.push(element.content.replace(/\s+/g, ' '));
                    }
                    if (f && element.content.includes('小写') && containStr.includes('小写')) {
                        contentList.push(element.content.substring(5, element.content.length).replace(/\s+/g, ''));
                    }
                });
            }
            else {
                var ele = this.getElementByContent(page, containStr, '', '');
                if (ele) {
                    if (containStr.includes('：') || containStr.includes(':'))
                        contentList.push(ele.content.substring(containStr.length, ele.content.length).replace(/\s+/g, ''));
                    else
                        contentList.push(ele.content.substring(containStr.length + 1, ele.content.length).replace(/\s+/g, ''));
                }
            }
        }
        else {
            if (containStr.includes('购买方名称')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('称：') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方名称')) {
                page.partitionFou.map(function (element) {
                    if (element.content.includes('称：') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('购买方纳税人识别号')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('识别号：')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方纳税人识别号')) {
                page.partitionFou.map(function (element) {
                    if (element.content.includes('识别号：')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
        }
        return contentList;
    };
    Invoice.prototype.analysisZZSZYFP = function (containStr, page) {
        var contentList = [];
        if (!containStr.includes('购') && !containStr.includes('销')) {
            if ((containStr.includes('项目名称') || containStr.includes('金额')
                || containStr.includes('税率') || containStr.includes('税额')) && containStr !== '税额合计') {
                var g = void 0, tmp_11, selElement = void 0;
                selElement = this.getElementByContent(page, containStr, '', '');
                if (selElement && selElement.geometry) {
                    g = new BaseGeometry(selElement.geometry.vertexes);
                    tmp_11 = [g.points[0], [g.points[0][0], page.detailHeight]];
                    contentList = [];
                    page.elements.map(function (element) {
                        if (element.geometry) {
                            var f = element.geometry.lineIntersect(tmp_11[0], tmp_11[1], element.geometry.points[0], element.geometry.points[1]);
                            if (f) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        }
                    });
                    if (contentList.length === 0) {
                        g = new BaseGeometry(selElement.geometry.vertexes);
                        tmp_11 = [g.position, [g.position[0], page.detailHeight]];
                        contentList = [];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_11[0], tmp_11[1], element.geometry.points[0], element.geometry.points[1]);
                            if (f) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        });
                    }
                    if (contentList.length === 0) {
                        g = new BaseGeometry(selElement.geometry.vertexes);
                        tmp_11 = [g.points[2], [g.points[2][0], page.detailHeight]];
                        contentList = [];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_11[0], tmp_11[1], element.geometry.points[0], element.geometry.points[1]);
                            if (f) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        });
                    }
                }
            }
            else if (containStr === '合计' || containStr === '税额合计') {
                var selElement = this.getElementByContent(page, '合计', '价税合计', '');
                var tmp_12 = [[selElement.geometry.points[1][0], selElement.geometry.position[1]], [page.transverseLength, selElement.geometry.position[1]]];
                page.elements.map(function (element) {
                    var f = element.geometry.lineIntersect(tmp_12[0], tmp_12[1], element.geometry.points[0], element.geometry.points[3]);
                    if (f && contentList.length === 0) {
                        contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                    }
                    if (f && contentList.length > 0 && containStr === '税额合计') {
                        contentList.pop();
                        contentList.push(element.content.substring(1, element.content.length).replace(/\s+/g, ''));
                    }
                });
            }
            else if (containStr.includes('价税合计')) {
                if (containStr.includes('大写')) {
                    var selElement = this.getElementByContent(page, '大写', '', '');
                    if (selElement) {
                        var tmp_13 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_13[0], tmp_13[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f && contentList.length === 0 && containStr.includes('大写')) {
                                contentList.push(element.content.replace(/\s+/g, ''));
                            }
                        });
                    }
                }
                else if (containStr.includes('小写')) {
                    var selElement = this.getElementByContent(page, '小写', '', '');
                    if (selElement && selElement.content.length > '（小写）'.length) {
                        contentList.push(selElement.content.substring(selElement.content.indexOf('）') + 2, selElement.content.length).replace(/\s+/g, ''));
                    }
                    else if (selElement) {
                        var tmp_14 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_14[0], tmp_14[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f) {
                                contentList.push(element.content.substring(element.content.indexOf(')') + 2, element.content.length).replace(/\s+/g, ''));
                            }
                        });
                    }
                }
            }
            else {
                var ele = this.getElementByContent(page, containStr, '', '');
                if (ele) {
                    if (containStr.includes('：') || containStr.includes(':'))
                        contentList.push(ele.content.substring(containStr.length, ele.content.length).replace(/\s+/g, ''));
                    else
                        contentList.push(ele.content.substring(containStr.length + 1, ele.content.length).replace(/\s+/g, ''));
                }
            }
        }
        else {
            if (containStr.includes('购买方名称')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('名称') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方名称')) {
                page.partitionTwo.map(function (element) {
                    if (element.content.includes('名称') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('购买方纳税人识别号')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('识别号')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方纳税人识别号')) {
                page.partitionTwo.map(function (element) {
                    if (element.content.includes('识别号')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
        }
        return contentList;
    };
    Invoice.prototype.analysisHFFP = function (containStr, page) {
        var contentList = [];
        if (!containStr.includes('购') && !containStr.includes('销')) {
            if (containStr.includes('价税合计')) {
                if (containStr.includes('大写')) {
                    var selElement = this.getElementByContent(page, '大写', '', '');
                    if (selElement) {
                        var tmp_15 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_15[0], tmp_15[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f && contentList.length === 0 && containStr.includes('大写')) {
                                contentList.push(element.content.replace(/\s+/g, ' '));
                            }
                        });
                    }
                }
                else if (containStr.includes('小写')) {
                    var selElement = this.getElementByContent(page, '小写', '', '');
                    if (selElement && selElement.content.length > '（小写）'.length) {
                        contentList.push(selElement.content.substring(selElement.content.indexOf('）') + 2, selElement.content.length).replace(/\s+/g, ''));
                    }
                    else if (selElement) {
                        var tmp_16 = [selElement.geometry.position, [page.transverseLength, selElement.geometry.position[1]]];
                        page.elements.map(function (element) {
                            var f = element.geometry.lineIntersect(tmp_16[0], tmp_16[1], element.geometry.points[0], element.geometry.points[3]);
                            if (f) {
                                contentList.push(element.content.substring(element.content.indexOf(')') + 2, element.content.length).replace(/\s+/g, ''));
                            }
                        });
                    }
                }
            }
            else {
                var ele = this.getElementByContent(page, containStr, '', '');
                if (ele) {
                    if (containStr.includes('：') || containStr.includes(':'))
                        contentList.push(ele.content.substring(containStr.length, ele.content.length).replace(/\s+/g, ''));
                    else
                        contentList.push(ele.content.substring(containStr.length, ele.content.length).replace(/\s+/g, ''));
                }
            }
        }
        else {
            if (containStr.includes('购买方名称')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('名称') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方名称')) {
                page.partitionTwo.map(function (element) {
                    if (element.content.includes('名称') && contentList.length === 0) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('购买方纳税人识别号')) {
                page.partitionOne.map(function (element) {
                    if (element.content.includes('识别号')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
            if (containStr.includes('销售方纳税人识别号')) {
                page.partitionTwo.map(function (element) {
                    if (element.content.includes('识别号')) {
                        contentList.push(element.content.substring(element.content.includes('：') ? element.content.indexOf('：') + 1 : element.content.indexOf(':') + 1).replace(/\s+/g, ''));
                    }
                });
            }
        }
        return contentList;
    };
    return Invoice;
}());
var TrainTickets = /** @class */ (function () {
    function TrainTickets(pages) {
        this.pages = [];
        this.pages = pages;
    }
    TrainTickets.prototype.getElementByContent = function (type, containStr, page) {
        var ele, elementId;
        if (containStr === '发票号码') {
            page.partitionOne.map(function (element) {
                if (element.content.includes('发票号码')) {
                    if (containStr.includes('：') || containStr.includes(':'))
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr === '开票日期') {
            page.partitionTwo.map(function (element) {
                if (element.content.includes('开票日期')) {
                    if (containStr.includes('：') || containStr.includes(':'))
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr === '到达站') {
            page.partitionTwo.map(function (element) {
                if (element.content.includes('站')) {
                    ele = element;
                }
            });
        }
        if (containStr === '始发站') {
            page.partitionOne.map(function (element) {
                if (element.content.includes('站')) {
                    ele = element;
                }
            });
        }
        if (containStr === '乘车时间') {
            page.elements.map(function (element) {
                if (element.content.includes('开') && !element.content.includes('开票') && element.content.includes('年')) {
                    ele = page.getElementById(element.id);
                    ele.content = ele.content.substring(0, 11);
                }
                else if (element.content.includes('开') && element.content.includes(':') && !element.content.includes('开票')) {
                    ele = page.getElementById(element.id - 1);
                }
                else if (element.content.includes('开') && element.content.includes('：') && !element.content.includes('开票')) {
                    ele = page.getElementById(element.id - 1);
                }
            });
        }
        if (containStr === '票价') {
            page.elements.map(function (element) {
                if (element.content.includes('票价')) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId).content.substring(4);
        }
        if (containStr === '乘车人') {
            page.partitionFou.map(function (element) {
                if (element.content.includes('电子客票号')) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId - 1);
        }
        if (containStr.includes('购买方名称')) {
            page.elements.map(function (element) {
                if (element.content.includes('购买方名称')) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId);
            ele = ele.content.substring(6);
        }
        if (containStr.includes('统一社会信用代码')) {
            page.elements.map(function (element) {
                if (element.content.includes('统一社会信用代码')) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId);
            ele = ele.content.substring(9);
        }
        return ele;
    };
    return TrainTickets;
}());
var AirTickets = /** @class */ (function () {
    function AirTickets(pages) {
        this.pages = [];
        this.pages = pages;
    }
    AirTickets.prototype.analysePreprocessing = function (pages) {
        var ele;
        pages.map(function (page) {
            page.elements.map(function (element) {
                if (element.content.includes('电子客票号码')) {
                    ele = element;
                }
            });
            page.setDetailHeight(Number(ele.geometry.points[0][1] - (ele.geometry.points[2][1] - ele.geometry.points[1][1])));
        });
    };
    AirTickets.prototype.getElementByContent = function (type, containStr, page) {
        var ele, elementId = 0;
        if (containStr === '发票号码') {
            page.partitionTwo.map(function (element) {
                if (element.content.includes('发票号码')) {
                    if (element.content.includes('：') || element.content.includes(':'))
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr === '开票日期') {
            page.partitionThr.map(function (element) {
                if (element.content.includes('填开日期')) {
                    if (element.content.includes('：') || element.content.includes(':'))
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr === '填开单位') {
            page.partitionFou.map(function (element) {
                if (element.content.includes('填开单位')) {
                    if (element.content.includes('：') || element.content.includes(':'))
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr.includes('购买方名称')) {
            page.partitionFou.map(function (element) {
                if (element.content.includes('购买方名称')) {
                    if (element.content.includes('：') || element.content.includes(':'))
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr.includes('统一社会信用代码')) {
            page.partitionThr.map(function (element) {
                if (element.content.includes('纳税人识别号')) {
                    if (element.content.includes('：') || element.content.includes(':'))
                        ele = element.content.substring(containStr.length + 1, element.content.length).replace(/\s+/g, '');
                    else
                        ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr.includes('票价')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId);
            ele = ele.content.substring(4, ele.content.length);
        }
        if (containStr.includes('燃油附加费')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId + 1);
            ele = ele.content.substring(4, ele.content.length);
        }
        if (containStr.includes('增值税税率')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId + 2);
            ele = ele.content.substring(0, ele.content.length);
        }
        if (containStr.includes('增值税税额')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId + 3);
            ele = ele.content.substring(4, ele.content.length);
        }
        if (containStr.includes('民航发展基金')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId + 4);
            ele = ele.content.substring(4, ele.content.length);
        }
        if (containStr.includes('其他税费')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId + 5);
            ele = ele.content.substring(4, ele.content.length);
        }
        if (containStr.includes('旅客姓名')) {
            var g_2, tmp_17, selElement = void 0, contentList_1 = [];
            page.partitionOne.map(function (element) {
                if (element.content.includes('旅客姓名')) {
                    elementId = element.id;
                }
            });
            selElement = page.getElementById(elementId);
            g_2 = new BaseGeometry(selElement.geometry.vertexes);
            tmp_17 = [g_2.points[0], [g_2.points[0][0], page.detailHeight]];
            page.elements.map(function (element) {
                if (g_2 && element.geometry) {
                    var f = element.geometry.lineIntersect(tmp_17[0], tmp_17[1], element.geometry.points[0], element.geometry.points[1]);
                    if (f && contentList_1.length == 0) {
                        contentList_1.push(element);
                        ele = element.content;
                    }
                }
            });
        }
        if (containStr === '自：') {
            page.elements.map(function (element) {
                if (element.content.includes('自')) {
                    ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
                }
            });
        }
        if (containStr.includes('至：')) {
            var contentList_2 = [];
            elementId = 0;
            page.elements.map(function (element) {
                if (element.content.includes('至')) {
                    contentList_2.push(element);
                    // ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '')
                }
            });
            contentList_2.map(function (element) {
                if (element.content.length > 3)
                    ele = element.content.substring(containStr.length, element.content.length).replace(/\s+/g, '');
            });
        }
        if (containStr.includes('合计')) {
            page.elements.map(function (element) {
                if (element.content.includes('CNY') && elementId == 0) {
                    elementId = element.id;
                }
            });
            ele = page.getElementById(elementId + 6);
            ele = ele.content.substring(4, ele.content.length);
        }
        return ele;
    };
    return AirTickets;
}());
//# sourceMappingURL=OCRElement.js.map